function Home() {
    return (<h1>
        Home rules!
    </h1>);
}

export default Home;
